import { render, staticRenderFns } from "./DeprecationDetailOverlay.vue?vue&type=template&id=601de45b"
import script from "./DeprecationDetailOverlay.vue?vue&type=script&lang=js"
export * from "./DeprecationDetailOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('601de45b')) {
      api.createRecord('601de45b', component.options)
    } else {
      api.reload('601de45b', component.options)
    }
    module.hot.accept("./DeprecationDetailOverlay.vue?vue&type=template&id=601de45b", function () {
      api.rerender('601de45b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DeprecationDetailOverlay.vue"
export default component.exports